import { call, put, takeLeading } from 'redux-saga/effects';
import { componentMasterActions } from '../reducers/component-master';
import componentMasterService from '../api/componentMasterService';

function* getComponentMasterData({ payload }: any): any {
  const res = yield call(componentMasterService.fetchComponents, payload);
  if (res.status === 'success') {
    yield put(componentMasterActions.getServicesDataResponse(res));
  } else {
    yield put(componentMasterActions.getServicesDataFailed(res?.code));
  }
}

function* addComponentMaster({ payload }: any): any {
  const res = yield call(componentMasterService.addComponents, payload);
  if (res.status === 'success') {
    yield put(componentMasterActions.addServiceResponse(res?.code));
  } else {
    yield put(componentMasterActions.addServiceFailed(res?.code));
  }
}

function* updateComponentMaster({ payload }: any): any {
  const res = yield call(componentMasterService.updateComponents, payload);
  if (res.status === 'success') {
    yield put(componentMasterActions.updateServiceResponse(res?.code));
  } else {
    yield put(componentMasterActions.updateServiceFailed(res?.code));
  }
}

function* removeComponentMaster({ payload }: any): any {
  const res = yield call(componentMasterService.removeComponents, payload);
  if (res.status === 'success') {
    yield put(componentMasterActions.removeServiceResponse(res?.code));
  } else {
    yield put(componentMasterActions.removeServiceFailed(res?.code));
  }
}

function* componentMasterSaga() {
  yield takeLeading('componentMaster/getServicesDataRequest', getComponentMasterData);
  yield takeLeading('componentMaster/addServiceRequest', addComponentMaster);
  yield takeLeading('componentMaster/removeServiceRequest', removeComponentMaster);
  yield takeLeading('componentMaster/updateServiceRequest', updateComponentMaster);
}

export default componentMasterSaga;
